"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-25.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};

type BannerSectionH1sItem = {
    key: Key | null | undefined;
};
export type HomeTwelveBannerSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "5698+" */
    sectionDiv0Div0Div0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "Results has been delivered" */
    sectionDiv0Div0Div0Div0Div0Div0Div1P0Span0SpanText?: ReactNode;
    /** Default: "Search" */
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Type to search for any result" */
    sectionDiv0Div0Div0Div0Div0Div1Input0InputPlaceholder?: string;
    /** Default: "Accurate Lab" */
    sectionDiv0Div0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Results Delivered" */
    sectionDiv0Div0Div0Div0Div0H10H1Text2?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "to Your Doorstep" */
    sectionDiv0Div0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "Trusted, fast, and precise laboratory testing powered by advanced technology and qualified professionals around the world." */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-lab-img.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-lab-2.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-10.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Thyroid Tests" */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "Diabetes Tests" */
    sectionDiv0Div0Div1Div0P1PText?: ReactNode;
    /** Default: "Infection Tests" */
    sectionDiv0Div0Div1Div0P2PText?: ReactNode;
    /** Default: "Blood Tests" */
    sectionDiv0Div0Div1Div0P3PText?: ReactNode;
    /** Default: "shadow" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-shadow-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-lab-shdaow-1.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-lab-shadow.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon-3.svg" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionAvatarAvatarRoundeds: BannerSectionAvatarAvatarRoundedsItem[];
    bannerSectionH1s: BannerSectionH1sItem[];
    bannerSectionAvatarAvatarRoundedsItemWrapper?: (item: BannerSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageVisible?: boolean;
    bannerSectionAvatarAvatarRoundedsImageRenderer?: (item: BannerSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionH1sItemWrapper?: (item: BannerSectionH1sItem, content: ReactNode) => ReactNode;
    bannerSectionH1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeTwelveBannerSectionGenerated: FC<HomeTwelveBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div0Div1P0PText = "5698+",
    sectionDiv0Div0Div0Div0Div0Div0Div1P0Span0SpanText = "Results has been delivered",
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonText = "Search",
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Div0Div1Button0ButtonProps,
    sectionDiv0Div0Div0Div0Div0Div1Input0InputPlaceholder = "Type to search for any result",
    sectionDiv0Div0Div0Div0Div0H10H1Text = "Accurate Lab",
    sectionDiv0Div0Div0Div0Div0H10H1Text2 = "Results Delivered",
    sectionDiv0Div0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0Div0H10Span0SpanText = "to Your Doorstep",
    sectionDiv0Div0Div0Div0Div0P0PText = "Trusted, fast, and precise laboratory testing powered by advanced technology and qualified professionals around the world.",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-lab-img.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-lab-2.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/icons/banner-icon-10.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps,
    sectionDiv0Div0Div1Div0P0PText = "Thyroid Tests",
    sectionDiv0Div0Div1Div0P1PText = "Diabetes Tests",
    sectionDiv0Div0Div1Div0P2PText = "Infection Tests",
    sectionDiv0Div0Div1Div0P3PText = "Blood Tests",
    sectionImageWithBasePath0ImageAlt = "shadow",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-shadow-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "shadow",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-lab-shdaow-1.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "shadow",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-lab-shadow.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "shadow",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/icons/banner-icon-3.svg",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    bannerSectionAvatarAvatarRoundeds,
    bannerSectionH1s,
    bannerSectionAvatarAvatarRoundedsItemWrapper,
    bannerSectionAvatarAvatarRoundedsRenderer,
    bannerSectionAvatarAvatarRoundedsImageVisible,
    bannerSectionAvatarAvatarRoundedsImageRenderer,
    bannerSectionAvatarAvatarRoundedsImageProps,
    bannerSectionH1sItemWrapper,
    bannerSectionH1sRenderer,
}) => {
    return (
        <section className="banner-section-twelve">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-6">
                        <div className="banner-left wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="section-header section-header-nine">
                                <div className="rating-appointment flex-wrap">
                                    <div className="avatar-list-stacked avatar-group-lg">
                                        {renderCollectionNode(
                                            bannerSectionAvatarAvatarRoundeds,
                                            (item: BannerSectionAvatarAvatarRoundedsItem) => (
                                                <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                    {renderItemNode(bannerSectionAvatarAvatarRoundedsImageVisible, bannerSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof bannerSectionAvatarAvatarRoundedsImageProps === "function" ? bannerSectionAvatarAvatarRoundedsImageProps(item) : (bannerSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </span>
                                            ),
                                            bannerSectionAvatarAvatarRoundedsItemWrapper,
                                            bannerSectionAvatarAvatarRoundedsRenderer
                                        )}
                                        <span className="avatar avatar-rounded bg-primary d-inline-flex align-items-center justify-content-center">
                                            <i className="isax isax-add fs-24" />
                                        </span>
                                    </div>
                                    <div>
                                        <p className="avatar-ttile">
                                            {sectionDiv0Div0Div0Div0Div0Div0Div1P0PText}
                                            <span>{sectionDiv0Div0Div0Div0Div0Div0Div1P0Span0SpanText}</span>
                                            {" "}
                                        </p>
                                    </div>
                                </div>
                                {renderNode(sectionDiv0Div0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="section-title mb-0 mb-2" {...(sectionDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0Div0H10H1Text}
                                        {renderCollectionNode(
                                            bannerSectionH1s,
                                            (item: BannerSectionH1sItem) => (
                                                <br key={item.key} />
                                            ),
                                            bannerSectionH1sItemWrapper,
                                            bannerSectionH1sRenderer
                                        )}
                                        {sectionDiv0Div0Div0Div0Div0H10H1Text2}
                                        <br />
                                        <span>{sectionDiv0Div0Div0Div0Div0H10Span0SpanText}</span>
                                        {" "}
                                    </h1>
                                ))}
                                <p className="paragraph">{sectionDiv0Div0Div0Div0Div0P0PText}</p>
                                <div className="search-input">
                                    <i className="isax isax-search-normal search-icon" />
                                    <input type="text" placeholder={sectionDiv0Div0Div0Div0Div0Div1Input0InputPlaceholder} className="form-control" />
                                    {renderNode(sectionDiv0Div0Div0Div0Div0Div1Button0ButtonVisible, sectionDiv0Div0Div0Div0Div0Div1Button0ButtonRenderer, (
                                        <button className="btn btn-success" {...(sectionDiv0Div0Div0Div0Div0Div1Button0ButtonProps ?? {})}>{sectionDiv0Div0Div0Div0Div0Div1Button0ButtonText}</button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="banner-img-twelve wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid banner-lab-img" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid banner-lab-img-2" {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt} className="img-fluid banner-icon-3" {...(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps ?? {})} />
                            ))}
                            <p className="badge one">{sectionDiv0Div0Div1Div0P0PText}</p>
                            <p className="badge two">{sectionDiv0Div0Div1Div0P1PText}</p>
                            <p className="badge three">{sectionDiv0Div0Div1Div0P2PText}</p>
                            <p className="badge four">{sectionDiv0Div0Div1Div0P3PText}</p>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid shadow-img" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid shadow-img1" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid shadow-img2" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="img-fluid shadow-img3" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwelveBannerSectionGenerated;
